export default __webpack_public_path__ + "static/media/thumb-GNSS-Receiver-6.4a573028.png";